/**
 * External dependencies
 */
import { reduce, get, omitBy } from 'lodash';

/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.LOCATION_GROUPS_RECEIVE]: (state, action) => {

            return reduce(
                action.payload.locationGroups,
                (memo, locationGroup) => {
                    const { id } = locationGroup;
                    if (memo === state) {
                        memo = { ...memo };
                    }
                    memo[id] = locationGroup;
                    return memo;
                },
                state,
            );
        },
        [actions.DELETE_LOCATION_GROUP_SUCCESS]: (state, action) => {
            const locationGroupId = get(action, ['payload', ['locationGroupId']]);
            const items = { ...state };
            return omitBy(items, { id: locationGroupId })
        }
    },
);